<template>
  <div class="navs l_o_btm">
    <!--      环球底部-->
      <router-link to="/opera/indexHuanQiu">
        <div class="nav">
          <i class="iconfont icon-shouye " :class="{active:sta=='1','icon-shouyeH': sta=='1',}"></i>
          <p>{{$t('footNav_home')}}</p>
        </div>
      </router-link>
      <router-link to="/opera/fangTHuanQiu">
        <div class="nav">
          <i class="iconfont icon-DDLB" style="transform: scale(1.2)" :class="{active:sta=='2','icon-DDLBH': sta=='2'}"></i>
          <p>
            <span>{{ $t('fangT_title') }}</span>
          </p>
        </div>
      </router-link>
      <router-link to="/opera/centerHuanQiu">
        <div class="nav">
          <i class="iconfont icon-gerenzhongxin" :class="{active:sta=='3','icon-gerenzhongxinH': sta=='3'}"></i>
          <p>
            <span>{{$t('footNav_center')}}</span>
          </p>
        </div>
      </router-link>
  </div>
</template>
<script>
export default {
  props: ["sta"],
  data() {
    return {
      infoCount: 0,
      isHuanQiu: false,
    };
  },
  mounted() {
    this.getData();
    this.getGlobalPermission()
  },
  methods: {
    getGlobalPermission(){
      this.$http.get("/mobilepmsapi/sysOptions/findOptionByOpen").then(res => {
        if (res.data.result == 0) {
          let retVal = res.data.retVal || {};
          this.hideAdvertise = !!retVal.hideAdvertise;
          localStorage.setItem('CustomersOpen', retVal.CustomersOpen ? "yes" : 'no') // 客源范围的日期删选
          localStorage.setItem('OrderCountForRoomNumber', retVal.OrderCountForRoomNumber ? "yes" : 'no') // 客源范围的日期删选
          localStorage.setItem('rateChange',retVal.rateChange ? "yes" : 'no') // 判断用户是否是 ADMIN
          localStorage.setItem('isAdmin', retVal.isAdmin ? "yes" : 'no') // 判断用户是否是 ADMIN
          localStorage.setItem('isJingJiang', retVal.isJingJiang ? "yes" : 'no') // 判断用户是否是 ADMIN
          localStorage.setItem('isHuanQiu', retVal.isHuanQiu ? "yes" : 'no') // 判断用户是否是 ADMIN
          localStorage.setItem('mihotelBinding', retVal.mihotelBinding ? "yes" : 'no') // 环球用户是否有权限控制用户当日房态
          localStorage.setItem('mihotelLogSee', retVal.mihotelLogSee ? "yes" : 'no') // 环球查看日志
          localStorage.setItem('useMhPermission', retVal.useMhPermission ? "yes" : 'no') // 判断用户是否是 ADMIN
          localStorage.setItem('isOpenReport1ArgPyear',retVal.isOpenReport1ArgPyear ? true : false) // 是否开启自定义选择年份功能
          this.isHuanQiu = retVal.isHuanQiu
        }
      });
    },
    getData() {
      if (localStorage.getItem("JWT_TOKEN")) {
        this.$http
          .get("/mobilepmsapi/message/unreadMessageNumber")
          .then(res => {
            this.infoCount = res.data.retVal;
            if (this.$isApp) {
              plus.runtime.setBadgeNumber(this.infoCount);
              if (plus.os.name == "iOS") {
                var GeTuiSdk = plus.ios.importClass("GeTuiSdk");
                GeTuiSdk.setBadge(this.infoCount);
              }
            }
          });
      }
    }
  }
};
</script>
<style lang='less' scoped>
.navs {
  box-shadow: 0 -0.0533rem 0.5333rem rgba(0, 0, 0, 0.1);
  position: fixed;
  z-index: 1000;
  bottom: 0px;
  width: 100%;
  height: 1.1733rem;
  background-color: #fff;
  .nav {
    float: left;
    width: 33.3%;

    &.isHuanQiu{
      width: 50%;
    }

    text-align: center;
    position: relative;
    line-height: normal;
    .iconfont {
      margin-top: 0.1333rem;
      font-size: 0.5333rem;
      color: #b1b1b1;
      display: inline-block;
      &.active {
        color: #f6a623;
      }
    }
    p {
      height: 0.5333rem;
      font-size: 0.32rem;
      color: #999;
      -webkit-transform-origin-x: center;
      -webkit-transform: scale(0.9);
      transform: scale(0.9);
    }
    .message {
      background: red;
      width: 0.4rem;
      height: 0.4rem;
      line-height: 0.4rem;
      position: absolute;
      top: 0;
      right: 1.2rem;
      color: #fff;
      border-radius: 50%;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// huanQiufootNav.vue?786dad2b